/* eslint-disable max-len */
import commonFunctions from '../../common-functions';

export default {
    /**
     * Nombre del componente
     */
    name: 'Conciliation2Historic',

    extends: commonFunctions,

    props: {
        data: {
            type: Array,
            required: true
        }
    },

    data() {

        return {
            product: '',
            currency: ''
        };
    },

    created() {
    },

    mounted() {
        this.product = this.$route.query.product;
        this.currency = this.$route.query.currency;
        this.disableSelection = false;
    },

    methods: {
        changeHistoricSelected(item, event) {
            if (event) {
                this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/setComment`, item.comment);
                item['bank-operations'].forEach(element => {
                    const payload = {
                        action: 'add',
                        item: element
                    };
                    this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/selectBankOperation`, payload);
                });
                item['rd-operations'].forEach(element => {
                    const payload = {
                        action: 'add',
                        item: element
                    };
                    this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/selectRDOperation`, payload);
                });
                this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/setGroupedSelected`, true);
                this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/setUuidGroupedSelected`, item.uuid);
            }
        }
    },

    computed: {
        historicSelected: {
            get() {
                const item = this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/uuidGroupedSelected`];
                this.disableSelection = !!item;
                return item;
            },
            set(newName) {
                return newName;
            }
        }
    }
};
